const initialCharacters = (value: string) =>
  Array.from(value).filter((character) => /[\p{L}\p{N}]/u.test(character))

export function userInitials(
  displayName?: string | null,
  email?: string | null,
): string {
  const emailName = email?.split('@')[0] ?? ''
  const source = displayName?.trim() || emailName.trim() || 'Voxnela'
  const words = source
    .split(/[\s._-]+/u)
    .map((word) => initialCharacters(word))
    .filter((word) => word.length > 0)

  const characters =
    words.length > 1
      ? [words[0]?.[0], words.at(-1)?.[0]]
      : words[0]?.slice(0, 2)

  return (characters ?? ['V'])
    .filter((character): character is string => Boolean(character))
    .join('')
    .toLocaleUpperCase('tr-TR') || 'V'
}
